<template>
    <div>
        <wmt-header></wmt-header>
        <!-- <wmt-summits></wmt-summits> -->
        <wmt-contact-us></wmt-contact-us>
        <wmt-footer></wmt-footer>
    </div>
</template>

<script>
import wmtHeader from '../../components/wmt-header/wmt-header.vue';
import wmtContactUs from '../../components/wmt-contactUs/wmt-contactUs.vue';
import wmtFooter from '../../components/wmt-footer/wmt-footer.vue';
export default {
    components: {
        wmtHeader,
        wmtContactUs,
        wmtFooter
    },
}
</script>